import React, { useEffect, useState } from 'react'
import Sidebar from '../../Components/Sidebar'
import TopHeader from '../../Components/TopHeader'
import PageHeader from '../../Components/PageHeader'
import BannerPage from '../../Components/Banner'
import DisplayGallerySection from './DisplayGallerySection'
import { useGalleryStore } from '../../store/useGalleryStore'
import GallerySection from "./GallerySection"
import { Box, Button, Modal, Typography } from '@mui/material'
import Loader from '../../Components/Loader'

const Gallery = () => {
    const { getgalleryimage, gallery, deletegallerySection } = useGalleryStore();
    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [pageNumber, setPageNumber] = useState(1);
    const [editId, setEditId] = useState(null);
    const [search, setSearch] = useState('');
    const [itemId, setItemId] = useState(null);
    const [field, setField] = useState('');
    const [open, setOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);

    const getPaginatedGallery = async () => {
        setLoading(true)
        let res = await getgalleryimage('', '', search, field)
        if (res) {
            setTotalPages(res?.totalPages);
        }
        setLoading(false)
    }

    const onEdit = async (id) => {
        setEditId(id)
        setOpen(true)
    }


    const handleCancelDelete = () => {
        setDeleteOpen(false);
    };

    const handleConfirmDelete = async () => {
        try {
            setDeleteOpen(false)
            setLoading(true)
            const res = await deletegallerySection(itemId)
            setDeleteOpen(false)
            setLoading(false)
        } catch (error) {
            setLoading(false)
            setDeleteOpen(false)
            console.log(error)
        }
    }

    const handleAddNewGallerySection = (id) => {
        setOpen(!open);
        setEditId(null);
    }

    const handleCancel = () => {
        setOpen(false);
        // window.location.reload();
    };

    const onDelete = async (id) => {
        setItemId(id)
        setDeleteOpen(true)
    }

    useEffect(() => {
        getPaginatedGallery()
    }, [pageNumber, search, field])
    return (
        <div id="admin-dashboard" className="flex h-[800px] bg-neutral-100">

            <Sidebar />

            {/* <!-- Main Content Area --> */}
            <div id="main-content" className="flex-1 flex flex-col overflow-hidden">
                {/* <!-- Top Navigation Bar --> */}
                <TopHeader pageName="Content Management" />

                {/* <!-- Content Container --> */}
                <div id="content-container" className="flex-1 overflow-auto p-6">
                    {/* <!-- Page Header --> */}
                    <PageHeader />
                    <BannerPage pageName={'gallery'} />
                    <Loader loading={loading}>
                        <div id="story-section" className="bg-white rounded-md shadow-sm border border-neutral-200 overflow-hidden mb-6">
                            <div className="px-6 py-4 border-b border-neutral-200 bg-neutral-50 flex justify-between">
                                <h3>Gallery Section</h3>
                                <button
                                    className="px-4 py-2 bg-neutral-900 text-white rounded-md"
                                    onClick={() => {
                                        handleAddNewGallerySection()
                                    }}
                                >
                                    Add New Section
                                </button>
                            </div>
                            {
                                (gallery || []).map((ele, index) => (
                                    <div key={index}>
                                        <h1 className='ml-7 pt-7 text-[17px] font-[700]'>{`Section ${index + 1}`}</h1>
                                        <DisplayGallerySection
                                            formData={ele}
                                            onEdit={(ele) => onEdit(ele?._id)}
                                            onDelete={(ele) => onDelete(ele?._id)}
                                        />
                                    </div>
                                ))
                            }

                        </div>
                    </Loader>
                    <Modal
                        open={open}
                        onClose={handleCancel}
                        aria-labelledby="confirm-delete-modal"
                        aria-describedby="modal-to-confirm-deletion"
                    >
                        <Box
                            sx={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                backgroundColor: 'white',
                                padding: '20px',
                                borderRadius: '5px',
                                boxShadow: 24,
                                width: { xs: "80%", md: "700px" },
                            }}
                        >
                            <GallerySection
                                handleCancel={handleCancel}
                                setOpen={setOpen}
                                id={editId}
                            />
                        </Box>
                    </Modal>
                    <Modal
                        open={deleteOpen}
                        onClose={handleCancelDelete}
                        aria-labelledby="confirm-delete-modal"
                        aria-describedby="modal-to-confirm-deletion"
                    >
                        <Box
                            sx={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                backgroundColor: 'white',
                                padding: '20px',
                                borderRadius: '5px',
                                boxShadow: 24,
                                width: { xs: "80%", md: "500px" },
                                textAlign: 'center',
                            }}
                        >
                            <Typography variant="h6" gutterBottom>
                                Are you sure you want to delete this Gallery Section?
                            </Typography>
                            <Button variant="outlined" color="#274156" onClick={handleConfirmDelete}>
                                Yes
                            </Button>
                            <Button variant="outlined" color="#274156" onClick={handleCancelDelete} sx={{ marginLeft: '10px' }}>
                                No
                            </Button>
                        </Box>
                    </Modal>
                </div>
            </div>
        </div>
    )
}

export default Gallery
